<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<!-- Debug overlay flotante (auto-hidden salvo activación explícita).
     Activar con: localStorage.setItem('debugOverlay','1') + recargar.
     O por URL: ?debug=1   ·   Desactivar: localStorage.removeItem('debugOverlay') -->
<app-debug-overlay></app-debug-overlay>
